var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDrink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgb(69, 110, 141)",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 420.001 420.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M173.385,135.274V31.839c0-3.783-3.067-6.85-6.852-6.85h-3.156l3.182-16.868c0.378-2.004-0.156-4.072-1.457-5.643 C163.8,0.909,161.866,0,159.827,0h-31.119c-2.039,0-3.973,0.909-5.274,2.479c-1.301,1.57-1.835,3.639-1.458,5.643l3.183,16.868 h-3.156c-3.784,0-6.852,3.067-6.852,6.85v103.435c-10.26,6.418-39.028,26.64-39.028,51.561V413.15 c0,3.783,3.068,6.851,6.851,6.851h122.59c3.782,0,6.851-3.065,6.851-6.851V186.834 C212.413,161.914,183.645,141.692,173.385,135.274z M137.678,339.188h-43.98v-94.297h43.98V339.188z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.47,306.05c19.79-31.771,8.986-85.1,3.422-106.553c-0.959-3.701-4.299-6.285-8.122-6.285h-89.247 c-3.823,0-7.164,2.584-8.123,6.284c-5.563,21.453-16.367,74.779,3.424,106.553c7.977,12.81,20.166,20.631,36.231,23.256v64.514 h-18.638c-7.219,0-13.091,5.873-13.091,13.091c0,7.219,5.873,13.091,13.091,13.091h63.458c7.218,0,13.091-5.873,13.091-13.091 s-5.873-13.091-13.091-13.091h-18.638v-64.514C312.303,326.68,324.493,318.857,332.47,306.05z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDrink);
export default __webpack_public_path__ + "static/media/menuDrink.a015a5628524ae883002bce35add643a.svg";
export { ForwardRef as ReactComponent };